import { api } from "@/http/api-client"
import type { TGetMembershipResponse } from "./types"

export function getMembership(slug: string) {
  return api.get<TGetMembershipResponse>(`/organizations/${slug}/membership`)
}
